export default __webpack_public_path__ + "static/media/MaterialComposer_Template.77a46a1b.pdf";